import axios, {AxiosError, AxiosRequestConfig, AxiosResponse} from 'axios';
import AppSession from '@/store/AppSession';
import store from '@/store';
import ApiUtils from '@/utils/ApiUtils';
import {trackErrorEventRaygun} from '@/plugins/raygun';

declare const appProp: any;

axios.defaults.baseURL = appProp.origin;
axios.interceptors.request.use((config: AxiosRequestConfig) => {
    const token = AppSession.getAccessToken();
    if (token) {
        config.headers.Authorization = `${token}`;
    }
    
    const defaultParam = store.getters.param;
    const passedParam = config.params;
    config.params = {...defaultParam, ...passedParam};
    
    if (config.method === 'get') {
        const {pageNo, rowCount} = config.params;
        if (isNaN(pageNo) || pageNo === undefined) {
            config.params.pageNo = 1;
        }
        
        if (isNaN(rowCount) || rowCount === undefined) {
            config.params.rowCount = 20;
        }
    }
    return config;
});

axios.interceptors.response.use(
    (response: AxiosResponse) => {
        if (!response.data.success) {
            trackErrorEventRaygun(response.data.errMsg);
        }
        return response;
    },
    (error: AxiosError) => {
        trackErrorEventRaygun(error.response?.data);
        const message = error.response?.data?.errMsg;
        const data = {
            level: 'FATAL',
            userId: store.getters.userId,
            userKey: store.getters.userKey,
            token: AppSession.getAccessToken(),
            message,
            route: {
                params: {
                    appendix: store.getters.param.appendix,
                    language: store.getters.param.language,
                    senderKey: store.getters.param.senderKey,
                    sponsorKey: store.getters.param.sponsorKey,
                },
            },
            additional: {
                error,
                category: 'AXIOS_ERROR',
            }
        };
    
        const ignore = error.config?.params?.ignore;
        // 무한루프 방지
        if (ignore !== 'ALL') {
            ApiUtils.sendLog('/api/v1/logs/error', data);
        }
    
        if (error.response?.status === 500) {
            if (error.request.responseType === 'blob') {
                return ApiUtils.handleFileDownloadFailResponse(error.response);
            } else {
                return Promise.reject(error.response?.data?.errMsg ?? error);
            }
        } else {
            return Promise.reject(error);
        }
    }
);
